import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DataProvider } from './src/context/DataContext';
import { BankingProvider } from './src/context/BankingContext';
import { CRMProvider } from './src/context/CRMContext';
import { ProjectProvider } from './src/context/ProjectContext';
import { TimeTrackingProvider } from './src/context/TimeTrackingContext';
import { BillProvider } from './src/context/BillContext';
import { AuthGuard } from './src/components/AuthGuard';
import { Layout } from './src/components/layout/Layout';
import { Login } from './src/pages/Login';
import { Dashboard } from './src/pages/Dashboard';
import { Customers } from './src/pages/Customers';
import { CustomerView } from './src/pages/CustomerView';
import { Invoices } from './src/pages/Invoices';
import { InvoiceForm } from './src/pages/InvoiceForm';
import { Subscriptions } from './src/pages/Subscriptions';
import { SubscriptionForm } from './src/pages/SubscriptionForm';
import { SalesTax } from './src/pages/SalesTax';
import { SalesReport } from './src/pages/SalesReport';
import { Settings } from './src/pages/Settings';
import { PublicInvoiceView } from './src/pages/PublicInvoiceView';
import { PublicSubscriptionView } from './src/pages/PublicSubscriptionView';
import { PublicWholesaleSetup } from './src/pages/PublicWholesaleSetup';
import { CashFlow } from './src/pages/CashFlow';
import { JobProfit } from './src/pages/JobProfit';
import { NetProfit } from './src/pages/NetProfit';
import { BalanceSheet } from './src/pages/BalanceSheet';
import { HighValueCustomers } from './src/pages/HighValueCustomers';
import { LeadFlow } from './src/pages/LeadFlow';
import { LeadForm } from './src/pages/LeadForm';
import { ContactView } from './src/pages/ContactView';
import { Funnel } from './src/pages/Funnel';
import { ProjectFlow } from './src/pages/ProjectFlow';
import { CostTracking } from './src/pages/CostTracking';
import { BillFlow } from './src/pages/BillFlow';
import { NotFound } from './src/pages/NotFound';
export function App() {
  useEffect(() => {
    document.title = 'Multi-Company Billing System';
  }, []);
  return <DataProvider data-id="element-0">
      <BankingProvider data-id="element-1">
        <CRMProvider data-id="element-2">
          <ProjectProvider data-id="element-3">
            <TimeTrackingProvider data-id="element-4">
              <BillProvider data-id="element-5">
                <BrowserRouter data-id="element-6">
                  <AuthGuard data-id="element-7">
                    <Routes data-id="element-8">
                      {/* Login route - NO layout wrapper */}
                      <Route path="/login" element={<Login data-id="element-10" />} data-id="element-9" />

                      {/* Public routes - NO layout wrapper */}
                      <Route path="/public/invoice/:hash" element={<PublicInvoiceView data-id="element-12" />} data-id="element-11" />
                      <Route path="/public/subscription/:hash" element={<PublicSubscriptionView data-id="element-14" />} data-id="element-13" />
                      <Route path="/public/wholesale-setup/:companyId" element={<PublicWholesaleSetup data-id="element-16" />} data-id="element-15" />

                      {/* 404 catch-all - NO layout wrapper */}
                      <Route path="/404" element={<NotFound data-id="element-18" />} data-id="element-17" />

                      {/* Admin routes - WITH layout wrapper */}
                      <Route path="*" element={<Layout data-id="element-20">
                            <Routes data-id="element-21">
                              {/* Sales Flow routes */}
                              <Route path="/" element={<Dashboard data-id="element-23" />} data-id="element-22" />
                              <Route path="/customers" element={<Customers data-id="element-25" />} data-id="element-24" />
                              <Route path="/customers/:id" element={<CustomerView data-id="element-27" />} data-id="element-26" />
                              <Route path="/invoices" element={<Invoices data-id="element-29" />} data-id="element-28" />
                              <Route path="/invoices/new" element={<InvoiceForm data-id="element-31" />} data-id="element-30" />
                              <Route path="/invoices/:id" element={<InvoiceForm data-id="element-33" />} data-id="element-32" />
                              <Route path="/invoices/:id/edit" element={<InvoiceForm data-id="element-35" />} data-id="element-34" />
                              <Route path="/subscriptions" element={<Subscriptions data-id="element-37" />} data-id="element-36" />
                              <Route path="/subscriptions/new" element={<SubscriptionForm data-id="element-39" />} data-id="element-38" />
                              <Route path="/subscriptions/:id" element={<SubscriptionForm data-id="element-41" />} data-id="element-40" />
                              <Route path="/sales-tax" element={<SalesTax data-id="element-43" />} data-id="element-42" />
                              <Route path="/sales-report" element={<SalesReport data-id="element-45" />} data-id="element-44" />
                              <Route path="/settings" element={<Settings data-id="element-47" />} data-id="element-46" />

                              {/* Cash Flow routes */}
                              <Route path="/cash-flow" element={<CashFlow data-id="element-49" />} data-id="element-48" />
                              <Route path="/job-profit" element={<JobProfit data-id="element-51" />} data-id="element-50" />
                              <Route path="/net-profit" element={<NetProfit data-id="element-53" />} data-id="element-52" />
                              <Route path="/balance-sheet" element={<BalanceSheet data-id="element-55" />} data-id="element-54" />
                              <Route path="/high-value-customers" element={<HighValueCustomers data-id="element-57" />} data-id="element-56" />

                              {/* Lead Flow routes */}
                              <Route path="/lead-flow" element={<LeadFlow data-id="element-59" />} data-id="element-58" />
                              <Route path="/lead-flow/new" element={<LeadForm data-id="element-61" />} data-id="element-60" />
                              <Route path="/lead-flow/edit/:id" element={<LeadForm data-id="element-63" />} data-id="element-62" />
                              <Route path="/lead-flow/view/:id" element={<ContactView data-id="element-65" />} data-id="element-64" />
                              <Route path="/funnel" element={<Funnel data-id="element-67" />} data-id="element-66" />

                              {/* Project Flow routes */}
                              <Route path="/projects" element={<ProjectFlow data-id="element-69" />} data-id="element-68" />

                              {/* Cost Flow routes */}
                              <Route path="/cost-tracking" element={<CostTracking data-id="element-71" />} data-id="element-70" />

                              {/* Bill Flow routes */}
                              <Route path="/bill-flow" element={<BillFlow data-id="element-73" />} data-id="element-72" />

                              {/* 404 catch-all - redirect outside layout */}
                              <Route path="*" element={<Navigate to="/404" replace data-id="element-75" />} data-id="element-74" />
                            </Routes>
                          </Layout>} data-id="element-19" />
                    </Routes>
                  </AuthGuard>
                </BrowserRouter>
              </BillProvider>
            </TimeTrackingProvider>
          </ProjectProvider>
        </CRMProvider>
      </BankingProvider>
    </DataProvider>;
}